<template>
  <div class="serveCheckList">
    <div class="serveCheckList-top">
      <Form ref="selectForm" :model="applySearch" :label-width="90" class="tabTopForm">
        <FormItem label="审核状态" class="select1">
          <Select
            v-model="applySearch.checkState"
            clearable
            placeholder="请选择审核状态"
            @on-change="searchApply"
            @on-clear="searchApply"
          >
            <Option v-for="item in checkStateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="服务场景">
          <Select
            class="select"
            v-model="applySearch.scene"
            clearable
            placeholder="请选择服务场景"
            @on-change="searchApply"
            @on-clear="searchApply"
          >
            <Option v-for="item in sceneList" :value="item.v" :key="item.v">
              {{
              item.k
              }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="服务提供者">
          <Input
            clearable
            v-model.trim="applySearch.proName"
            placeholder="请输入服务提供者名称"
            style="width: 100%; min-width: 160px"
            class="inputName"
            @on-blur="searchApply"
            @on-clear="searchApply"
            @on-enter="searchApply"
          />
        </FormItem>
        <FormItem label class="name" :label-width="20">
          <Input
            clearable
            v-model.trim="applySearch.name"
            placeholder="请输入服务名称"
            class="inputName"
            @on-blur="searchApply"
            @on-clear="searchApply"
            @on-enter="searchApply"
          />
        </FormItem>
      </Form>
    </div>
    <div class="content">
      <Row>
        <Table
          class="tableDom"
          ref="tableRef"
          stripe
          :columns="dataCol"
          :loading="tableLoading"
          :data="dataList"
        >
          <!-- 序号 -->
          <template slot-scope="{ index }" slot="xuhao">{{ index + 1 }}</template>
          <!-- logo -->
          <template slot-scope="{ row }" slot="logo">
            <img
              :src="row.imgUrl"
              alt
              class="logo"
              v-if="
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.') + 1,
                  row.imgUrl.length
                ) == 'png' ||
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.') + 1,
                  row.imgUrl.length
                ) == 'jpg' ||
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.') + 1,
                  row.imgUrl.length
                ) == 'jpeg' ||
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.') + 1,
                  row.imgUrl.length
                ) == 'bmp' ||
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.') + 1,
                  row.imgUrl.length
                ) == 'gif' ||
                row.imgUrl.substring(
                  row.imgUrl.lastIndexOf('.'),
                  row.imgUrl.length
                ) == '.'
              "
            />

            <img v-else src="@/assets/img/avatar.png" alt class="logo" />
          </template>
          <!-- 'png', 'jpg', 'jpeg', 'bmp', 'gif'图片 -->
          <!-- 服务类型 -->
          <template slot-scope="{ row }" slot="serviceType">
            <div>{{ getKforV(serveUseList, row.serviceUsedType) }}</div>
          </template>
          <!-- <template slot-scope="{ row }" slot="sceneList">
            <div>{{ getKforV(serveTypeList, row.sceneList) }}</div>
          </template>-->
          <!-- 审核状态1审核中 2已通过(不显示)  4已驳回 5申请下架 -->
          <template slot-scope="{ row }" slot="state">
            <div v-if="row.status == 1">
              <span class="dot1"></span>
              待审核
            </div>
            <div v-if="row.status == 2">
              <span class="dot3"></span>
              审核通过
            </div>
            <div v-if="row.status == 4">
              <span class="dot2"></span>
              已驳回
            </div>
            <div v-if="row.status == 5">
              <span class="dot3"></span> 申请下架
            </div>
          </template>
          <!-- 操作 -->
          <template slot-scope="{ row }" slot="action">
            <span>
              <span
                class="fontblue mr-16 fontcursor"
                @click="link('/serve/servecheckinfo', row)"
                v-permission="['detail']"
                v-if="row.status == 4"
              >查看详情</span>
            </span>
            <span>
              <span
                class="fontblue mr-16 fontcursor"
                v-permission="['audit']"
                v-if="row.status == 1 || row.status == 5"
                @click="link('/serve/servecheckinfo', row)"
              >审核</span>
              <span class="mr-16" v-if="(row.status == 1 || row.status == 5) && !isExamine">-</span>
            </span>
          </template>
        </Table>
      </Row>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="pageTotal"
          :page-size="pageSize"
          :page-size-opts="psize"
          :current="pageNum"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
  </div>
</template>

<script>
import { getServeChecklist } from "@/api/service";
import { getDict } from "@/api/dict";
import TableMixin from "@/utils/mixins/tableMixin";
const dataCol = [
  {
    title: "序号",
    slot: "xuhao",
    minWidth: 80,
    tooltip: true
  },
  {
    title: "服务logo",
    slot: "logo",
    minWidth: 100,
    tooltip: true
  },
  {
    title: "服务提供者",
    key: "oName",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "服务名称",
    key: "name",
    minWidth: 100,
    tooltip: true
  },
  {
    title: "服务使用类型",
    slot: "serviceType",
    minWidth: 100,
    tooltip: true
  },
  {
    title: "服务场景",
    key: "serviceScene",
    minWidth: 100,
    tooltip: true
  },
  {
    title: "审核状态",
    tooltip: true,
    minWidth: 100,
    slot: "state"
  },
  {
    title: "创建时间",
    key: "createTime",
    tooltip: true,
    minWidth: 180
  },
  {
    title: "操作",
    slot: "action",
    minWidth: 130
  }
];
export default {
  components: {},
  mixins: [mixins, TableMixin],
  data() {
    return {
      Recovery: {
        path: ["/serve/servecheckinfo"],
        key: ["applySearch", "pageSize", "pageNum"]
      },
      reasonsData: {},
      tableLoading: false,
      pageTotal: 0,
      pageSize: 10,
      psize: [10, 20, 50, 100],
      pageNum: 1,
      applySearch: {
        checkState: "",
        scene: "",
        proName: "",
        name: ""
      },
      // 审核状态
      checkStateList: [
        {
          id: 1,
          name: "待审核"
        },
        {
          id: 4,
          name: "已驳回"
        },
        {
          id: 5,
          name: "申请下架"
        }
      ],
      imgFlag: 0,
      serveTypeList: [],
      sceneList: [], //服务场景
      dataList: [], //申请列表
      dataCol: dataCol,
      search: {
        name: ""
      },
      showDialog: false,
      type: "add",
      dataForm: {},
      dataId: -1,
      showPwd: false,
      showTip: false, //操作提示
      showEdit: false, //修改应用
      serveUseList: [],
      isExamine: true //是否有审核权限
    };
  },
  created() {
    let self = this;
    let status = this.$route.query.status;
    if (status) {
      this.applySearch.checkState = status * 1;
    }
    let pagePermissionList = this.$store.state.pagePermissionList;
    if (pagePermissionList.length) {
      let target = pagePermissionList.find(item => item.id == 10039);
      if (target) {
        target.actionList.indexOf("audit") == -1 && (this.isExamine = false);
      }
    }
    console.log(this.$store.state.pagePermissionList);
    this.getScenceList(); //获取服务场景
    this.getServeList(); //获取服务类型
    this.getServeUse(); //获取服务使用类型
  },
  mounted() {
    this.isManager = _GLOBAL.isManager();
    this.userRole = _GLOBAL.isCertified();
  },
  methods: {
    //获取服务使用类型
    getServeUse() {
      getDict("SERVICE_USED_TYPE").then(res => {
        let json = res.data.data;
        this.serveUseList = json;
        console.log("服务使用类型", this.serveUseList);
      });
    },
    // 服务类型（字典）
    getServeList() {
      getDict("SERVICE_TYPE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          json.forEach(item => {
            item.name = item.k;
            item.id = item.v;
            item.active = false;
          });
          this.serveTypeList = json;
          console.log("服务类型列表", this.serveTypeList);
        } else {
          console.log("请求数据失败");
        }
      });
    },
    // 将服务类型id转换为对应的名称
    getKforV(list, state) {
      for (let k = 0; k < list.length; k++) {
        const element = list[k];
        if (element.v == state) return element.k;
      }
    },
    // 服务场景（字典）先获取场景在进行调用
    getScenceList() {
      getDict("SERVICE_SCENE").then(res => {
        if (res.data.code == 0) {
          let json = res.data.data;
          this.sceneList = json;
          console.log("服务场景列表", this.sceneList);
          this.getList();
        } else {
          console.log("请求数据失败-服务场景");
        }
      });
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    },
    // 查询申请
    searchApply() {
      this.pageNum = 1;
      // this.pageSize = 10;
      this.getList();
    },
    getList() {
      let query = {
        auditStatus: this.applySearch.checkState,
        serviceScene: this.applySearch.scene,
        providerName: this.applySearch.proName,
        serviceName: this.applySearch.name,
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      };
      console.log("query", query);
      getServeChecklist(query)
        .then(res => {
          let json = res.data.data;
          this.pageTotal = res.data.page.totalCount;
          this.dataList = json;
          console.log("服务审核", this.dataList);
          // 服务场景转换（将数组中对象的值转换为对应的场景名称，并且以，分割的字符串）
          if (this.dataList && this.dataList.length) {
            this.dataList.forEach(item => {
              if (item.serviceScene) {
                item.serviceScene = item.serviceScene.split(",");
                item.serviceScene.forEach((x, index) => {
                  let t = this.sceneList.find(y => y.v == x);
                  if (t) {
                    item.serviceScene[index] = t.k;
                  }
                });
                item.serviceScene = item.serviceScene.join(",");
              }
            });
          }
        })
        .catch(err => {
          console.log(err, "请求接口失败");
        });
    },
    handlePage(value) {
      let self = this;
      self.pageNum = value;
      self.getList();
    },
    sizeChange(value) {
      let self = this;
      self.pageSize = value;
      self.$nextTick(() => {
        self.getList();
      });
    }
  }
};
</script>

<style lang="scss">
.serveCheckList {
  width: 100%;
  height: 100%;
  background: #fff;
  &-top {
    padding: 20px;
    display: flex;
    justify-content: flex-end;
    margin-bottom: -30px;
    .tabTopForm {
      display: flex;
      flex-wrap: wrap;
      .select,
      .select1 {
        min-width: 150px;
      }

      .ivu-select-single .ivu-select-selection {
        height: 36px;
        padding-top: 2px;
      }
      // .scene {
      //   margin-right: -70px;
      // }
      // .name {
      //   margin-right: -70px;
      //   .inputName {
      //     min-width: 150px;
      //   }
      // }
    }
    &-btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
    }
  }
  .tableDom {
    width: 100%;
    .logo {
      width: 36px;
      height: 36px;
      border-radius: 50%;
    }
    .dot1 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #3c8aff;
      border-radius: 50%;
    }
    .dot2 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #f56c6c;
      border-radius: 50%;
    }
    .dot3 {
      display: inline-block;
      background: #ffa50f;
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
}
</style>
